
jQuery(function ($) {
    // Remove the 'no-js' <body> class
    $('html').removeClass('no-js');

    //if (!$.support.leadingWhitespace) {
    //    // Superfish for main navigation
    //    $('.menu-primary').superfish();
    //}

    $(function() {
        var pushMenu = new mlPushMenu(
            $('.sb-menu')[0],
            $('.sb-menu--trigger')[0],
            {
                wrapper: $('.site-container')[0]
            }
        );
    });

    //Disable pointer events on scroll
    var disablePointerEventsOnScroll = function() {
        var root = document.documentElement;
        var timer;

        window.addEventListener('scroll', function () {
            // User scrolling so stop the timeout
            clearTimeout(timer);
            // Pointer events has not already been disabled.
            if (!root.style.pointerEvents) {
                root.style.pointerEvents = 'none';
            }

            timer = setTimeout(function () {
                root.style.pointerEvents = '';
            }, 250);
        }, false);
    };
    disablePointerEventsOnScroll();

});
